export default function Footer() {
  return (
    <>
      {/* CTA 横幅 */}
      <section className="bg-background-50">
        <div className="mx-auto max-w-6xl px-4 py-10 md:px-6 md:py-14">
          <div className="relative overflow-hidden rounded-lg bg-foreground-950 px-6 py-10 text-center md:px-10 md:py-14">
            <div
              className="pointer-events-none absolute inset-0 opacity-[0.07]"
              style={{
                backgroundImage:
                  "radial-gradient(circle at 15% 15%, #D49527 0, transparent 38%), radial-gradient(circle at 85% 85%, #D93B24 0, transparent 45%)",
              }}
            ></div>
            <div className="relative">
              <p className="inline-flex items-center gap-2 rounded-full border border-accent-400/40 bg-accent-500/10 px-4 py-1.5 text-xs text-accent-200 md:text-sm">
                <i className="ri-verified-badge-fill text-accent-300"></i>
                认准唯一认证，始终浏览正版
              </p>
              <h2 className="mx-auto mt-5 max-w-2xl font-display text-2xl font-bold leading-snug text-background-50 md:text-4xl">
                现在就从认证通道，进入吃瓜官网正版入口
              </h2>
              <p className="mx-auto mt-4 max-w-xl text-sm leading-relaxed text-background-200 md:text-base">
                记住三步：核对域名 → 确认红色封签 → 开始浏览。有疑问随时回到本页对照认证与防伪说明。
              </p>
              <div className="mt-7 flex flex-col items-center justify-center gap-3 sm:flex-row">
                <a
                  href="#guide"
                  className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
                >
                  <i className="ri-arrow-right-up-line"></i>
                  直达官方地址
                </a>
                <a
                  href="#faq"
                  className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-200/40 px-6 py-3 text-sm font-medium text-background-100 transition-colors hover:bg-background-50/10"
                >
                  仍有疑问？查看 FAQ
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 页脚 */}
      <footer className="border-t border-background-200 bg-background-100">
        <div className="mx-auto max-w-6xl px-4 py-8 md:px-6">
          <div className="flex flex-col justify-between gap-6 sm:flex-row sm:items-start">
            <div>
              <a href="#top" className="flex items-center gap-2.5">
                <span className="flex h-8 w-8 items-center justify-center rounded-md bg-primary-500 text-background-50">
                  <i className="ri-water-flash-fill text-lg"></i>
                </span>
                <span className="font-display text-base font-bold text-foreground-950">吃瓜官网</span>
              </a>
              <p className="mt-3 max-w-sm text-xs leading-relaxed text-foreground-600 md:text-sm">
                本站为吃瓜官网唯一官方认证入口。请认准红色封签式认证角标，谨防仿冒站点。
              </p>
            </div>

            <div className="flex flex-wrap gap-x-10 gap-y-4">
              <ul className="space-y-2 text-xs text-foreground-600 md:text-sm">
                <li className="mb-2 text-xs font-semibold text-foreground-900">快速导航</li>
                <li><a href="#news" className="hover:text-primary-600">官方快讯</a></li>
                <li><a href="#channels" className="hover:text-primary-600">栏目导览</a></li>
                <li><a href="#fake" className="hover:text-primary-600">防伪识别</a></li>
              </ul>
              <ul className="space-y-2 text-xs text-foreground-600 md:text-sm">
                <li className="mb-2 text-xs font-semibold text-foreground-900">官方指引</li>
                <li><a href="#trust" className="hover:text-primary-600">官方认证</a></li>
                <li><a href="#guide" className="hover:text-primary-600">进入指南</a></li>
                <li><a href="#faq" className="hover:text-primary-600">常见问题</a></li>
              </ul>
            </div>
          </div>

          <div className="mt-7 flex flex-col items-center justify-between gap-3 border-t border-background-200 pt-5 sm:flex-row">
            <p className="text-xs text-foreground-500">© 2026 吃瓜官网 · 唯一官方认证地址</p>
            <p className="flex flex-wrap items-center justify-center gap-2 text-xs text-foreground-500">
              <i className="ri-shield-check-line text-primary-500"></i>
              仅通过本站认证通道进入，可确保访问正版官网
            </p>
          </div>
        </div>
      </footer>
    </>
  );
}